module.exports = __webpack_public_path__ + "static/gallery-img-27-d35c9d4c1136610bbfb6169827fde7e6.jpg";